import React from "react";
import { withRouter } from "react-router-dom";
import ImageBackground from "../common/imageBackground";
import ImageButton from "../common/imageButton";
import VideoPlayer from "../common/videoPlayer";
import Clock from "./src/clock";
import Temperature from "./src/temperature";
import OrientationVideo from "../FTG/videos/317441HD_Orientation_CVOD.mp4";
import MainMenuButton from "./images/1060_btn_menu.png";
import TVChannelsButton from "./images/1060_btn_tvchannels.png";
import "./styles.css";

class WelcomeVIW extends React.Component {
  /******************
   * Public methods *
   ******************/

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    return (
      <div className="welcome-viw">
        <ImageBackground id="background" isWelcomeVIW={true} />
        <div className="player-wrapper">
          <VideoPlayer id="viw" src={OrientationVideo} loopVideo={true} />
        </div>
        <Clock />
        <Temperature />
        <div id="navigation-bar">
          <ImageButton
            id="mainMenu"
            to="/"
            className="navigation-button"
            unhighlight={MainMenuButton}
            alt="Main Menu"
            current={false}
          />
          <ImageButton
            className="navigation-button"
            unhighlight={TVChannelsButton}
            alt="Channel Up/Down"
            current={false}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(WelcomeVIW);
